import CardGrid from "../components/CardGrid";
import { packages } from "../data/packages";

export default function Packages() {
  const allPackages = Object.entries(packages).flatMap(([category, items]) =>
    items.map(item => ({ ...item, category }))
  );

  return (
    <section className="section">
      <h2>Holiday & Safari Packages</h2>
      <p className="muted">Pre-built itineraries you can customize to your needs.</p>
      <CardGrid items={allPackages} />
    </section>
  );
}
